import React from "react";
import { MessageCircle } from "lucide-react";
import { INSTITUTE } from "@/lib/content";

export default function WhatsAppFloat() {
  const href = `https://wa.me/${INSTITUTE.whatsapp_number}?text=${encodeURIComponent(INSTITUTE.whatsapp_message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      className="fixed bottom-5 right-5 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <div className="relative pulse-dot">
        <div className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform">
          <MessageCircle className="w-7 h-7 text-white" fill="white" stroke="#25D366" strokeWidth={1.5} />
        </div>
      </div>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap text-xs font-semibold bg-gray-950 text-white px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden sm:block">
        Chat with us
      </span>
    </a>
  );
}
